"use client";

import { useId, type SVGProps } from "react";

export function ConvoIcon({ className, ...props }: SVGProps<SVGSVGElement>) {
  const gradientId = useId();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
      aria-hidden="true"
      {...props}
    >
      <defs>
        <linearGradient
          id={gradientId}
          x1="0"
          y1="0"
          x2="32"
          y2="32"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#e89070" />
          <stop offset="1" stopColor="#d9744b" />
        </linearGradient>
      </defs>
      <g transform="translate(32 0) scale(-1 1)">
        <path
          d="M13 0h6a13 13 0 0 1 13 13v6a13 13 0 0 1-13 13H5a5 5 0 0 1-5-5V13A13 13 0 0 1 13 0Z"
          fill={`url(#${gradientId})`}
        />
        <circle cx="9" cy="16" r="2" fill="#fff" />
        <circle cx="16" cy="16" r="2" fill="#fff" opacity="0.7" />
        <circle cx="23" cy="16" r="2" fill="#fff" opacity="0.4" />
      </g>
    </svg>
  );
}
